import { Container } from '../components/Container/Container';

export function Footer() {
  return (
    <footer className="bg-[#505050]">
      <Container
        contentClassName="py-8 gap-3 justify-between items-center flex-col md:flex-row"
        hasPadding
      >
        <span className="flex items-center text-sm text-white">Boyana Achovski © 2025</span>
        <div className="flex gap-4 items-center">
          <a
            href="https://linkedin.com"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="LinkedIn"
            className="hover:scale-110 transition-transform"
          >
            <svg
              width="24"
              height="24"
              fill="none"
              viewBox="0 0 24 24"
              stroke="white"
              strokeWidth="1.5"
            >
              <rect x="3" y="3" width="18" height="18" rx="5" stroke="white" strokeWidth="1.5" />
              <path
                d="M8 11v5M8 8v.01M12 16v-5m0 0a2 2 0 0 1 4 0v5"
                stroke="white"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </a>
          <a
            href="https://facebook.com"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Facebook"
            className="hover:scale-110 transition-transform"
          >
            <svg
              width="24"
              height="24"
              fill="none"
              viewBox="0 0 24 24"
              stroke="white"
              strokeWidth="1.5"
            >
              <rect x="3" y="3" width="18" height="18" rx="5" stroke="white" strokeWidth="1.5" />
              <path
                d="M16 8h-2a2 2 0 0 0-2 2v2h4v2h-4v4h-2v-4H8v-2h2v-2a4 4 0 0 1 4-4h2v2z"
                stroke="white"
                strokeWidth="1.5"
              />
            </svg>
          </a>
          <a
            href="https://www.threads.net/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Threads"
            className="hover:scale-110 transition-transform"
          >
            <svg
              width="24"
              height="24"
              fill="none"
              viewBox="0 0 24 24"
              stroke="white"
              strokeWidth="1.5"
            >
              <circle cx="12" cy="12" r="10" stroke="white" strokeWidth="1.5" />
              <path
                d="M12 7c2.5 0 4 1.5 4 3.5s-1.5 3.5-4 3.5-4-1.5-4-3.5S9.5 7 12 7z"
                stroke="white"
                strokeWidth="1.5"
              />
              <path d="M12 14v2" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
            </svg>
          </a>
          <a
            href="https://twitter.com"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Twitter"
            className="hover:scale-110 transition-transform"
          >
            <svg
              width="24"
              height="24"
              fill="none"
              viewBox="0 0 24 24"
              stroke="white"
              strokeWidth="1.5"
            >
              <rect x="3" y="3" width="18" height="18" rx="5" stroke="white" strokeWidth="1.5" />
              <path d="M8 8l8 8M16 8l-8 8" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
            </svg>
          </a>
        </div>
      </Container>
    </footer>
  );
}

export default Footer;
